import { defineMessages } from 'react-intl';

export default defineMessages({
    covMiscellaneous: {
        id: 'quoteandbind.PSCSpeLinLinedirectives.templates.Miscellaneous.Coverages',
        defaultMessage: 'Coverages'
    },
    formMiscellaneous:{
        id: 'quoteandbind.PSCSpeLinLinedirectives.templates.Miscellaneous.Endorsements',
        defaultMessage: 'Endorsements'
    }
});